import React from 'react'

export default function ManageOrders() {
  return (
    <div>ManageOrders</div>
  )
}
